module.exports = __webpack_public_path__ + "static/img/caseImg13.cb58801.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/caseImg13.jpg
// module id = DIja
// module chunks = 0